import {
  onBeforeMount,
  getCurrentScope,
} from 'vue'
import { useRefreshToken } from '@services/api/useRefreshToken/useRefreshToken'
import { handleAuthRedirects } from '@core/router/handleAuthRedirects'
import { isRefreshTokenForbidden } from '@services/api/useRefreshToken/forbiddenScenarios'
import { devLogger } from '@libs/fsc/utils/logger'
import { handleWorkerCheckTokenExpiration } from '@core/workers/auth/authWorkerHandlers'
import { createAuthWorker } from '@core/workers/auth/authWorkerClient'

// ***
// DEFAULTS
// ***

export function useUserAuth() {
  const {
    startRefreshTokenProcess,
    legacyRefreshTokenIsAboutToExpire,
    hideModal,
    isRefreshTokenModalVisible,
    startWorkerTokenExpirationCheck,
  } = useRefreshToken()

  // ***
  // REFRESH TOKEN PROCESS
  // ***

  async function handleRefreshTokenRequestProcess(isRefreshForbidden?: boolean) {
    const isForbidden = isRefreshForbidden ?? isRefreshTokenForbidden()

    if (legacyRefreshTokenIsAboutToExpire() && !isForbidden) {
      try {
        await startRefreshTokenProcess()
      } catch (error) {
        if (error instanceof Error && error.message === 'userDeniedRefreshToken') {
          handleAuthRedirects()
        } else {
          devLogger('[Client] error during refresh token process', 'error')
          window.location.pathname = '/auth/logout'
        }
      }
    }
  }

  function startRefreshTokenProcessWithAuthWorker() {
    const runner = () => {
      createAuthWorker()
      handleWorkerCheckTokenExpiration()
      startWorkerTokenExpirationCheck()
    }

    if (getCurrentScope()) {
      onBeforeMount(() => {
        runner()
      })
    } else {
      runner()
    }
  }

  return {
    handleRefreshTokenRequestProcess,
    startRefreshTokenProcessWithAuthWorker,
  }
}
